export const badgePortalId = "badge-portal";

// These enum values correspond to the copy that each FilterChip
// will use, but also corresponds to CSS to order them.
export enum FilterBadges {
  action = "Action",
  dateRange = "Date range",
  search = "Search",
  status = "Status",
  app = "App",
  zap = "Zap",
  folder = "Folder",
  owner = "Owner",
  clearAll = "Clear All",
  issuesZaps = "My Zap workflows",
  issuesDateRange = "Last 7 days",
}
